import { App as CapacitorApp } from '@capacitor/app';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { PluginListenerHandle } from '@capacitor/core';

function useCapacitorDeepLinks() {
  const navigate = useNavigate(); // Use useNavigate instead of useHistory

  useEffect(() => {
    let listenerHandle: PluginListenerHandle | undefined;
    console.log('useCapacitorDeepLinks');

    CapacitorApp.addListener('appUrlOpen', (data) => {
      // data.url is the full URL that opened the app
      // Example: https://yourdomain.com/invitation/abc/123
      try {
        const url = new URL(data.url);
        // Get the path after the domain
        const path = url.pathname + url.search + url.hash;
        // Use React Router to navigate
        navigate(path, { replace: true });
      } catch (e) {
        // Handle invalid URL
      }
    }).then(handle => {
      listenerHandle = handle;
    });

    return () => {
      if (listenerHandle) {
        listenerHandle.remove();
      }
    };
  }, [navigate]);
}

export default useCapacitorDeepLinks;